import React from 'react';
import styles from './InternalAdminTool.module.scss';

interface NoOrganisationProps {
  logoSrc: string;
}

const NoOrganisation: React.FC<NoOrganisationProps> = ({ logoSrc }) => {
  return (
    <div className={styles.container}>
      <img 
        src={logoSrc} 
        alt="ACC Logo" 
        className={styles.grayscaleLogo} 
      />
      <div className={styles.message}>
        Please access the Internal Admin Tool from Workspace Admin
      </div>
    </div>
  );
};

export default NoOrganisation;
